<div class="wrapper-page admin-blogs">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <span class="header-text">Blogovi</span>
      <div class="">
        <button class="zc-btn zc-btn--primary" (click)="createBlog()"><span>Dodaj blog</span>
        </button>
      </div>
    </div>
    <div class="grid__m-12">
      <div class="zc-wrapper-tabs">
        <div class="zc-tab" [ngClass]="{'active': urlParams.blogType === BlogTypeEnum.active}" (click)="onChangeActiveTab(BlogTypeEnum.active)">
          <span>Aktivni</span>
        </div>
        <div class="zc-tab" [ngClass]="{'active': urlParams.blogType === BlogTypeEnum.inactive}" (click)="onChangeActiveTab(BlogTypeEnum.inactive)">
          <span>Neaktivni</span>
        </div>
        <div class="zc-tab" [ngClass]="{'active': urlParams.blogType === BlogTypeEnum.draft}" (click)="onChangeActiveTab(BlogTypeEnum.draft)">
          <span>Draft</span>
        </div>
      </div>
    </div>
    <div *ngIf="!blogs.length" class="wrapper-no-data">
      <span>Nema podataka</span>
    </div>
    <div *ngIf="blogs.length" class="admin-blogs-content">
      <div class="grid">
        <div *ngFor="let blog of blogs" class="grid__m-4">
          <button (click)="blogForDelete = blog.id">Obrisi</button>
          <div class="admin-card-blog" [routerLink]="[PAGES_AND_PATHS.adminEditBlog.pagePath, blog.id]">
            <div *ngIf="blog.is_featured" class="prominently-image">
              <img src="../../../../../assets/icons/landing/icon-star-blue.svg" alt="">
              <span>ISTAKNUTO</span>
            </div>
            <div class="header-admin-card-blog">
              <img [src]="blog.image?.full_path ? blog.image?.full_path : './assets/images/placeholder-image.png'" alt="">
            </div>
            <div class="content-admin-card-blog">
              <span class="admin-title-blog-card length-character">{{ blog.title ? blog.title : 'Nema naslov'}}</span>
              <span class="admin-subtitle-blog-card length-character-column length-character-column--2"[innerHTML]="blog.intro_text ? blog.intro_text : 'Nema opis'"></span>
              <div class="admin-footer-card">
                <div class="admin-wrapper-category">
                  <span>{{ blog.category ? blog.category : 'Nema kategoriju' }}</span>
                </div>
                <span class="admin-time-blog">{{ blog.created_at | timeAgo }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<gr-confirm-modal
  *ngIf="blogForDelete"
  [modalTitle]="'Brisanje bloga'"
  [modalDescription]="'Da li ste sigurni da želite da obrišete blog?'"
  (closeModal)="blogForDelete = null"
  (confirmModal)="removeBlog()">
</gr-confirm-modal>

